(function () {
    'use strict';

    function informationPartDocument(workflowStateService, zipbuilderDataService,
        notifyService, scrollingService, $timeout, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/informationPartDocument.html',
            scope: {
                identifier: '@',
                documentData: '=',
                parentData: '=',
                removeDocument: '&',
                deleteUpload: '&',
                canDelete: '=',
                mode: '=?',
                reorderMode: '=',
                stateUpdatedEventName: '@',
                updateDocumentPrompt: '&',
                sessionEntity: '=?',
                thumbnails: '='
            },
            link: function (scope, element, attrs) {
                scope.titleContext = '';
                scope.editTitleData = {
                    Title: '',
                    OriginalTitle: ''
                };

                scope.showPartners = !(scope.parentData.Id && scope.parentData.Id.indexOf('WorkflowInternalContents') > -1);

                scope.siblingNames = scope.parentData.InformationParts.filter(function (part) {
                    return !part.IsRemoved;
                }).map(function (p) { return p.Title; });

                scope.workflowTitleMode = scope.documentData.Access.Edit ? 'display': 'readonly';
                scope.editTitleData.Title = scope.documentData.Prompt;

                scope.editWorkflowTitle = function () {
                    scope.workflowTitleMode = 'edit';
                    scope.editTitleData.OriginalTitle = scope.editTitleData.Title;
                }

                scope.saveWorkflowTitle = function () {
                    scope.documentData.Prompt = scope.editTitleData.Title;
                    scope.updateDocumentPrompt();
                    scope.editTitleData.OriginalTitle = scope.editTitleData.Title;
                    scope.workflowTitleMode = 'display';
                    notifyService.notify('The ' + scope.titleContext + ' title has been updated');
                }

                scope.cancelSaveWorkflowTitle = function () {
                    scope.workflowTitleMode = 'display';
                    scope.editTitleData.Title = scope.editTitleData.OriginalTitle;
                }

                scope.toggleDetails = function () {
                    scope.documentData.isCollapsed = !scope.documentData.isCollapsed;
                }

                function updateZipDownloadButton(data) {
                    scope.showZipDownload = scope.documentData.BlobSummaries.filter(function (blob) {
                        return blob.Access.View && !blob.IsRemoved;
                    }).length > 1;

                    if (data) {
                        scope.zipDownloadBlobReference = data;
                        notifyService.notify('A zip file was created for ' +
                            scope.parentData.Prompt + ' - ' +
                            '<a style="text-decoration:underline;font-weight:bold;" href="' +
                            '/files/getupload?blobreference=' + scope.zipDownloadBlobReference +
                            '&fileName=' + scope.documentData.Path + '.zip">Download Zip File</a>');
                    }
                    else {
                        scope.zipDownloadBlobReference = null;
                    }
                }

                scope.buildZipFile = function () {
                    var data = {
                        Blobs: scope.documentData.BlobSummaries.filter(function(blob) {
                            return blob.Access.View && !blob.IsRemoved;
                        }).map(function(filteredBlob) {
                            return {
                                FileName: filteredBlob.FileName,
                                BlobReference: filteredBlob.BlobReference
                            };
                        })
                    };
                    scope.buildingZipFile = true;
                    zipbuilderDataService.build(data).then(function (data) {
                        scope.buildingZipFile = false;
                        updateZipDownloadButton(data);
                    }).catch(function (err) {
                        scope.buildingZipFile = false;
                    });
                };

                scope.$on(scope.stateUpdatedEventName, function () {
                    setHasAvailableContent();
                    scope.documentData.showZipDownload = updateZipDownloadButton();
                });

                updateZipDownloadButton();

                function setHasAvailableContent() {
                    scope.hasAvailableContent = scope.documentData.BlobSummaries.some(function (blob) { return !blob.IsRemoved && blob.Access.View; });
                }
                setHasAvailableContent();
                scope.hasNotesOrSharing = scope.documentData.Partners ||
                    scope.documentData.ProjectUnderwritingNotes;

                scope.removeUpload = function (blobIndex) {
                    // TODO: change this
                    scope.deleteUpload({ phase: scope.parentData, documentData: scope.documentData, blobIndex: blobIndex});

                    $rootScope.$emit('fileRemoved',
                        {
                            parent: scope.documentData
                        });
                }

                scope.toggleItem = function (item) {
                    if (item.Access.ShowPartners || item.Access.Notes) {
                        item.open = !item.open;
                    }

                    scrollingService.scrollTo(attrs.scrollToElementId + (item.open ? "_expanded" : ""),
                        item.open ? 0 : 250, 0, 0);

                    $rootScope.$emit('containerVisibilityChange',
                        {
                            containerName: scope.identifier,
                            isVisible: item.open
                        });
                }

                scope.onNoteAdded = function () {
                    scope.noteCount += 1;
                }

                scope.onNoteRemoved = function (noteId) {
                    var noteToRemoveIndex = scope.documentData.ProjectUnderwritingNotes.findIndex(function (note) {
                        return note.NoteId === noteId;
                    });

                    if (noteToRemoveIndex !== -1) {
                        scope.documentData.ProjectUnderwritingNotes.splice(noteToRemoveIndex, 1);
                    }
                    scope.noteCount -= 1;
                }

                scope.allowMultipleFiles = true;

                scope.canReorder = false;

                $rootScope.$watch(function () { return scope.reorderMode },
                    function (newVal) { scope.canReorder = newVal; });
            }
        };
    }

    informationPartDocument.$inject = ['workflowStateService', 'zipbuilderDataService',
        'notifyService', 'scrollingService', '$timeout', '$rootScope'];

    angular.module('ecap.common').directive('informationPartDocument', informationPartDocument);
})();

